import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { catchError, debounceTime, fromEvent, map, Subject } from "rxjs";
import { PagedResult } from "src/app/admin/models/common/pagination";
import {
  DonorRequestListDto,
  RequestAdminSearchDto,
} from "src/app/admin/models/donor-request-admin";
import { DonorRequestAdminService } from "src/app/admin/services/donor-request-admin.service";
import { BaseComponent } from "src/app/shared/base/base-component";
import { FileDto } from "src/app/shared/models/models";
import { FileDownloadService } from "src/app/shared/providers/file-download/file-download.service";

@Component({
  selector: "app-donor-request-admin-list",
  templateUrl: "./donor-request-admin-list.component.html",
  styleUrls: ["./donor-request-admin-list.component.scss"],
})
export class DonorRequestAdminListComponent
  extends BaseComponent
  implements OnInit
{
  @ViewChild("inputRef", { static: true }) inputRef: ElementRef;
  @ViewChild("dropdown") dropdown: NgbDropdown;
  private _error = new Subject<string>();
  errorMessage: string | null;
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public searchModel: RequestAdminSearchDto;
  public gridView: PagedResult<DonorRequestListDto>;
  filterInputFocus: boolean = false;

  constructor(
    private service: DonorRequestAdminService,
    private cd: ChangeDetectorRef,
    private fileDownloadService: FileDownloadService,
  ) {
    super();
  }
  ngOnInit(): void {
    this.resetSearchModel();
    this.fetch();
    const input$ = fromEvent(this.inputRef.nativeElement, "input").pipe(
      debounceTime(1500)
    );
    input$.subscribe(() => {
      this.refresh(1);
    });
  }
  fetch() {
    const sub = this.service
      .getAllAdminDonorRequests(this.searchModel).pipe(
        map((response: PagedResult<DonorRequestListDto>) => {
          this.gridView = response;
        }),
        catchError((err) => {
          if (err.status === 403)
            this.showErrorMessage(err.error.error.message);
          else
            this.translate.get('ErrorCodes.RetrieveError').subscribe(msg => this.showErrorMessage(msg));

          return this.logException(err);
        })
      )
      .subscribe();
    this.subscription.push(sub);
  }
  refresh(page: number) {
    this.searchModel.pageNumber = page;
    this.searchModel.KeyWord = this.searchModel.KeyWord;
    this.fetch();
  }
  onFocus() {
    this.filterInputFocus = true;
    this.cd.detectChanges();
  }
  onBlur() {
    this.filterInputFocus = false;
    this.cd.detectChanges();
  }
  onPageSizechange() {
    this.searchModel.pageNumber = 1;
    this.searchModel.pageSize = this.pageSize;
    this.fetch();
  }
  exportAsExcel() {
    this.service.ExportExcel(this.searchModel)
      .subscribe(
        (data: FileDto) => {
          if (data) this.fileDownloadService.downloadFromBytes(data);
        },
        (error) => {
          if (error.status === 403)
            this.translate.get(`${error.error.error.message}`).subscribe((msg) => this.showErrorMessage(msg));
          else
            this.translate.get("ErrorCodes.RetrieveError").subscribe((msg) => this.showErrorMessage(msg));
        }
      );
  }
  exportAsPdf() {
    this.service.ExportPdf(this.searchModel)
      .subscribe(
        (data: FileDto) => {
          if (data) this.fileDownloadService.downloadFromBytes(data);
        },
        (error) => {
          if (error.status === 403)
            this.translate.get(`${error.error.error.message}`).subscribe((msg) => this.showErrorMessage(msg));
          else
            this.translate.get("ErrorCodes.RetrieveError").subscribe((msg) => this.showErrorMessage(msg));
        }
      );
  }
  filterData(event: any) {
    this.refresh(1);
    this.toggleDropdown();
  }
  toggleDropdown() {
    if (this.dropdown.isOpen()) {
      this.dropdown.close();
    } else {
      this.dropdown.open();
    }
  }
  private resetSearchModel() {
    this.gridView = {} as PagedResult<DonorRequestListDto>;
    this.gridView.items = [];
    this.gridView.totalCount = 0;
    this.gridView.pageNumber = this.pageNumber;
    this.gridView.pageSize = this.pageSize;

    this.searchModel = {} as RequestAdminSearchDto;
    this.searchModel.pageSize = this.pageSize;
    this.searchModel.pageNumber = this.pageNumber;
  }
}
